let pcCommonMethods = {
    methods: {
        // //添加片头片尾
        changeHeadTail(type) {
            this.$store.commit("setInFixedVideo", 'click');
            if (type == 'Head') {
                this.playHead()
            } else if (type == 'Tail') {
                this.playTail()
            }
            const data = this.data.part_list;
            data.forEach((item, index) => {
                item.chapter_list.forEach((itm, idx) => {
                    itm.aliveStatus = false;
                });
            });
        },
        playHead() {
            this.$store.commit('Zhead', true)
            this.$store.commit('Ztail', false)
            this.$router.replace({ name: "Zhead" });
        },
        playTail() {
            this.$store.commit('Zhead', false)
            this.$store.commit('Ztail', true)
            this.$router.replace({ name: "Ztail" });
        },
        // // 去第一章节或者最后一章节
        // goto(type){
        //   if(type == 'first'){
        //     // alert('去第一章节')
        //     this.$store.commit("currentPartIndex", 0); //当前章节数组下标
        //     this.$store.commit("currentChapterIndex", 0); //当前小节数组下标
        //     var item = this.data.part_list[0].chapter_list[0]
        //     let type, quiz, chapterId;
        //     type = item.chapter_type; //当前小节类型 1 视频  2.小测验  3.图文
        //     chapterId = item.chapter_id; //章节ID
        //     if (item.chapter_content) {
        //       quiz = item.chapter_content.quiz_type;
        //     }
        //     this.intoDetail(type, quiz, chapterId);
        //     // 以下是修改准中之后的样式
        //     this.data.part_list.forEach((item, index) => {
        //       item.chapter_list.forEach((itm, idx) => {
        //         if (itm.chapter_id === chapterId) {
        //           itm.aliveStatus = true;
        //         } else {
        //           itm.aliveStatus = false;
        //         }
        //       });
        //     });
        //   }else if(type == 'last'){
        //     // alert('去最后一章节')
        //     let pIndex = this.data.part_list.length-1
        //     let cIndex = this.data.part_list[pIndex].chapter_list.length-1

        //     this.$store.commit("currentPartIndex", pIndex); //当前章节数组下标
        //     this.$store.commit("currentChapterIndex", cIndex); //当前小节数组下标
        //     var item = this.data.part_list[pIndex].chapter_list[cIndex]
        //     let type, quiz, chapterId;
        //     type = item.chapter_type; //当前小节类型 1 视频  2.小测验  3.图文
        //     chapterId = item.chapter_id; //章节ID
        //     if (item.chapter_content) {
        //       quiz = item.chapter_content.quiz_type;
        //     }
        //     this.intoDetail(type, quiz, chapterId);
        //     // 以下是修改准中之后的样式
        //     this.data.part_list.forEach((item, index) => {
        //       item.chapter_list.forEach((itm, idx) => {
        //         if (itm.chapter_id === chapterId) {
        //           itm.aliveStatus = true;
        //         } else {
        //           itm.aliveStatus = false;
        //         }
        //       });
        //     });
        //   }
        // },
        // 输入检查全局提示
        subAnswerAllow(show) { // mutation
            this.$store.commit('pubMessboxShow', show)
            this.$store.commit('showPubAlertBg', show)
            setTimeout(() => {
                this.$store.commit('pubMessboxShow', !show)
                this.$store.commit('showPubAlertBg', !show)
            }, 1000)
        },
        // 切换小节
        chapterTurn(direc) {
            let pIndex = parseInt(this.$store.state.currentPartIndex)         // 当前章节下标
            let cIndex = parseInt(this.$store.state.currentChapterIndex)      // 当前小节下标
            let cIndexCopy = cIndex
            if (direc === 1 && !this.$store.state.Zhead) { // 下一页                                      // 1 下一页   -1 上一页
                cIndexCopy = cIndex + 1
            }
            if (direc === 1 && this.$store.state.Zhead) {
                this.$store.commit('currentPartIndex', 0)
                cIndexCopy = 0
                this.data.part_list[0].chapter_list[0].aliveStatus = true
            }
            if (direc === -1 && !this.$store.state.Ztail) { // 上一页
                cIndexCopy = cIndex - 1
            }
            if (direc === -1 && this.$store.state.Ztail) { // 上一页
                pIndex = this.data.part_list.length - 1;
                this.$store.commit('currentPartIndex', pIndex)
                cIndexCopy = this.data.part_list[pIndex].chapter_list.length - 1;
                this.data.part_list[pIndex].chapter_list[cIndexCopy].aliveStatus = true;
            }
            let data = this.data.part_list[pIndex].chapter_list[cIndexCopy]   //下一个或者上一个小节的数据

            if (data) {
                this.$store.commit('currentChapterIndex', cIndexCopy)
                this.intoDetailPage(this.data)
            } else {
                if (direc === 1) {
                    this.hasNextPart(pIndex + 1)
                } else if (direc === -1) {
                    this.hasPrevPart(pIndex)
                }
            }
            // 下一小节
            if (direc === 1) {
                if (!data) {
                    this.hasNextPart(pIndex)
                }
            }
            // 上一小节
            if (direc === -1) {
                if (!data) {
                    this.hasPrevPart(pIndex)
                }
            }
        },
        // 检测是否有下一章节
        hasNextPart(pIndex) {
            let data = this.data.part_list[pIndex + 1]
            if (data) {
                this.$store.commit('currentPartIndex', pIndex + 1)
                this.$store.commit('currentChapterIndex', 0)
            } else {
                return this.changeHeadTail('Tail')
            }
        },
        // 检测是否有上一章节
        hasPrevPart(pIndex) {
            if (this.data.part_list[pIndex - 1]) { // 是否存在上一章节
                this.$store.commit('currentPartIndex', pIndex - 1)
                this.$store.commit('currentChapterIndex', this.data.part_list[pIndex - 1].chapter_list.length - 1)
            } else {
                return this.changeHeadTail('Head')
            }
        },
        intoDetailPage(data) {
            const pIndex = this.$store.state.currentPartIndex
            const cIndex = this.$store.state.currentChapterIndex
            const chapterType = data.part_list[pIndex].chapter_list[cIndex].chapter_type
            const chapterId = data.part_list[pIndex].chapter_list[cIndex].chapter_id
            // console.log(111,'pIndex:'+pIndex,'cIndex:'+cIndex,'chapterType:'+chapterType)
            // console.log(333, chapterType)
            if (chapterType !== '2') {
                this.intoDetail(chapterType, 0, chapterId)
            } else {
                this.intoDetail(chapterType, data.part_list[pIndex].chapter_list[cIndex].chapter_content.quiz_type, chapterId)
            }
        },
        // PC小节路由跳转
        intoDetail(type, quiz, cid) {
            // // 清除片头片尾的被选中的样式
            this.$store.commit("Zhead", false);
            this.$store.commit("Ztail", false);
            type = parseInt(type)
            quiz = parseInt(quiz)
            switch (type) {
                case 1: // 视频
                    this.$router.replace({ path: '/pcindex/video', query: { cid } })
                    break
                case 2: // 小测验
                    this.intoQuiz(quiz, cid)
                    break
                case 3: // 文档
                    this.$router.replace({ path: '/pcindex/test', query: { cid } })
                    break
                case 4: // 图文
                    this.$router.replace({ path: '/pcindex/tuwen', query: { cid } })
                    break
            }
        },
        // 小测验跳转路由
        intoQuiz(quiz, cid) {
            switch (quiz) {
                case 1: // 单选
                    this.$router.replace({ path: '/pcindex/test/single', query: { type: quiz, cid } })
                    break
                case 2: // 多选
                    this.$router.replace({ path: '/pcindex/test/single', query: { type: quiz, cid } })
                    break
                case 3: // 问答
                    this.$router.replace({ path: '/pcindex/test/question', query: { type: quiz, cid } })
                    break
                case 4: // 拖拽单选
                    this.$router.replace({ path: '/pcindex/test/drag', query: { type: quiz, cid } })
                    break
                case 5: // 拖拽多选
                    this.$router.replace({ path: '/pcindex/test/drag', query: { type: quiz, cid } })
                    break
                case 6: // 多行填空
                    this.$router.replace({ path: '/pcindex/test/morelineBlank', query: { type: quiz, cid } })
                    break
                case 7: // 段落填空
                    this.$router.replace({ path: '/pcindex/test/fillblank', query: { type: quiz, cid } })
                    break
                case 8: // 判断
                    this.$router.replace({ path: '/pcindex/test/judge', query: { type: quiz, cid } })
                    break
            }
        },
        // ie11兼容
        isIE() {
            if ((/Trident\/7\./).test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        // // 检查是否是第一次进入该页面
        isFirst() {
            if (localStorage.pagecount) {
                localStorage.pagecount = Number(localStorage.pagecount) + 1;
            } else {
                localStorage.pagecount = 1;
            }
            if (localStorage.pagecount == 1) {
                return true
            } else {
                return false
            }
        },
    }

}
export default pcCommonMethods
